import { render, staticRenderFns } from "./fallback.vue?vue&type=template&id=3e997dc7&scoped=true&"
import script from "./fallback.vue?vue&type=script&lang=ts&"
export * from "./fallback.vue?vue&type=script&lang=ts&"
import style0 from "./fallback.vue?vue&type=style&index=0&id=3e997dc7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e997dc7",
  null
  
)

export default component.exports